import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';
import PhotoGallery from '../components/PhotoGallery';
import VideoGallery from '../components/VideoGallery';
import OnPageLoaded from '../utils/onpageloaded';
import WOW from 'wowjs';

class Gallery extends Component {
    /*constructor(props) {
        super(props);
        this.state = { scrolled: false };
        this.handleOnWindowScrol = this.handleOnWindowScrol.bind(this);
    }*/
    componentDidMount() {
        document.title = "Gruppo folk Damatrà - Foto e Video";
        const description = "Visualizza le foto e i video dei nostri concerti balfolk. Inviaci le tue foto dei nostri spettacoli a: info@damatrafolk.it, e saremo lieti di pubblicarle sul nostro sito.";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        OnPageLoaded(true, true);
        new WOW.WOW().init();
        //window.addEventListener("scroll", this.handleOnWindowScrol);
    }

    /*handleOnWindowScrol() {
        if (!this.state.scrolled) {
            //new WOW.WOW().init();
            this.setState({ scrolled: true });
        };
    }*/

    render() {
        return (
            <div>
                <PageTitle title="Foto & Video" bgimgurl="/img/titlebg/gallery.jpg"></PageTitle>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <section id="foto" className="section">
                                <div className="divider-new" style={{ marginTop: 10 }}>
                                    <h2 className="h2-responsive mx-4 wow fadeIn">
                                        Foto
                                    <i className="fas fa-camera descicon"></i>
                                    </h2>
                                </div>
                                <PhotoGallery />
                            </section>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <section id="video" className="section">
                                <div className="divider-new pt-5">
                                    <h2 className="h2-responsive mx-4 wow fadeIn">Video
                                    <i className="fas fa-video descicon"></i>
                                    </h2>
                                </div>
                                <VideoGallery />
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/pages/Gallery.js